export const generatedScenarioTraceabilityMatrix = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-scenario-traceability-matrix",
  "operatingRule": "Every scenario row must trace ranking, uncertainty, assumptions, claims, source payload state, runtime sidecar state, economics/resource blockers, and model hashes before it can be used in paid diligence.",
  "scenarioCount": 6,
  "blockedTraceCount": 6,
  "promotionAllowed": false,
  "evidenceHashes": {
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
    "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
    "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
    "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
    "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
    "sidecarRunSpecPacket": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
    "sidecarArtifactTemplatePacket": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
    "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
    "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
    "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030"
  },
  "traces": [
    {
      "scenarioId": "moon-first",
      "name": "Moon-first Bootstrap",
      "rank": 1,
      "decisionLane": "lane-2-conditional-diligence",
      "promotionState": "blocked-for-commercial-proof",
      "commercializationAllowed": false,
      "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c",
      "deterministicScores": {
        "benefitScore": 66.95,
        "riskScore": 33.91,
        "uncertaintyPenalty": 8,
        "utility": 67.12
      },
      "uncertainty": {
        "iterations": 128,
        "utilityP10": 65.53,
        "utilityMedian": 67.34,
        "utilityP90": 68.89,
        "downsideSpread": 1.81,
        "seed": "moon-first-decision-ledger"
      },
      "economics": {
        "businessReadinessMedian": 76.65,
        "businessReadinessP10": 71.87,
        "businessReadinessP90": 81.23,
        "medianProgramNeedBn": 49.36,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 75.78,
        "underfundedProbabilityPercent": 0
      },
      "topDrivers": {
        "benefits": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 76,
            "weight": 1,
            "weightedValue": 76
          },
          {
            "kind": "benefit",
            "criterion": "resourceConfidence",
            "rawScore": 74,
            "weight": 1,
            "weightedValue": 74
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 70,
            "weight": 1,
            "weightedValue": 70
          }
        ],
        "risks": [
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 48,
            "weight": 0.9,
            "weightedValue": 43.2
          },
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 42,
            "weight": 1,
            "weightedValue": 42
          },
          {
            "kind": "risk",
            "criterion": "processMaturity",
            "rawScore": 38,
            "weight": 0.8,
            "weightedValue": 30.4
          }
        ]
      },
      "runRefs": [
        {
          "id": "run-conservative-moon-first-2026-06-19",
          "runHash": "sha256-f58e6bfe5aae47d6d92365d8b83e1843a5dbf18a3fd82cad81824110d7346601",
          "claimState": "model-derived-unvalidated",
          "selectedUtility": 67.12,
          "purpose": "Stress test proving Mercury-first is not hardcoded and conservative assumptions can prefer nearer infrastructure.",
          "inputHashes": {
            "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
            "weights": "sha256-248f44bffa52cd71b631edd713a8877d08ce98083b44f4965678cd9290e7d51f",
            "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
            "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
            "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
          },
          "evidenceHashes": {
            "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
            "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
            "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
          }
        }
      ],
      "assumptionRefs": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "uncertainty": "Low",
          "utilityDelta": -0.11,
          "rankDelta": 0,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts.",
          "impactHash": "sha256-18d17b3a43121dce702111672030500b3f2312262307f39aadb9177aeff29eb8",
          "sourceCoverage": {
            "sourceCount": 4,
            "missingSourceIds": [],
            "primarySourceCount": 4,
            "recordHashes": [
              "fnv1a32-9335c241",
              "fnv1a32-93c0fe91",
              "fnv1a32-ba0c45bb",
              "fnv1a32-97d74c96"
            ]
          }
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "uncertainty": "Low",
          "utilityDelta": 0.2,
          "rankDelta": 0,
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury.",
          "impactHash": "sha256-af29cde19803c251fdb159311a364c052dcab8378ad33efccbe4fa6641075228",
          "sourceCoverage": {
            "sourceCount": 3,
            "missingSourceIds": [],
            "primarySourceCount": 3,
            "recordHashes": [
              "fnv1a32-9335c241",
              "fnv1a32-7c477cc2",
              "fnv1a32-78229f8d"
            ]
          }
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "Low",
          "utilityDelta": -0.08,
          "rankDelta": 0,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge.",
          "impactHash": "sha256-debdf52af9c609f7587809b69b32742d46d4550f56dbdecfae2dc25a5571fdad",
          "sourceCoverage": {
            "sourceCount": 0,
            "missingSourceIds": [],
            "primarySourceCount": 0,
            "recordHashes": []
          }
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "High",
          "utilityDelta": 0.44,
          "rankDelta": 0,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "impactHash": "sha256-4f535d33727617984ce47c8117d7e5b03da271ddd6a54e14c07b7a083a7675b3",
          "sourceCoverage": {
            "sourceCount": 0,
            "missingSourceIds": [],
            "primarySourceCount": 0,
            "recordHashes": []
          }
        }
      ],
      "claimRefs": [
        {
          "claimId": "claim-mercury-flux",
          "domain": "Energy",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373",
          "sourceRefs": [
            {
              "sourceId": "nasa-mercury",
              "title": "Mercury Facts",
              "trust": "primary",
              "recordHash": "fnv1a32-78229f8d",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-de440-boundary",
          "domain": "Ephemeris",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb",
          "sourceRefs": [
            {
              "sourceId": "horizons-api",
              "title": "JPL Horizons API",
              "trust": "primary",
              "recordHash": "fnv1a32-9335c241",
              "promotionState": "promoted-reviewed-snapshot"
            },
            {
              "sourceId": "spice-gf",
              "title": "SPICE Geometry Finder",
              "trust": "primary",
              "recordHash": "fnv1a32-97d74c96",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-helium3",
          "domain": "Resources",
          "evidenceGrade": "D-blocked",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4",
          "sourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Hypothesis, not Verified.",
            "Confidence 0.25 is below 0.8 promotion threshold."
          ]
        },
        {
          "claimId": "claim-spf-separation",
          "domain": "Manufacturing",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359",
          "sourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Likely, not Verified.",
            "Confidence 0.78 is below 0.8 promotion threshold.",
            "High-impact non-verified claim cannot support customer proof."
          ]
        },
        {
          "claimId": "claim-dtn",
          "domain": "Comms",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46",
          "sourceRefs": [
            {
              "sourceId": "nasa-dtn",
              "title": "Delay/Disruption Tolerant Networking",
              "trust": "primary",
              "recordHash": "fnv1a32-61e03fe6",
              "promotionState": "not-promoted-or-not-required-p0"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-mercury-core",
          "domain": "Resources",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9",
          "sourceRefs": [
            {
              "sourceId": "nasa-mercury",
              "title": "Mercury Facts",
              "trust": "primary",
              "recordHash": "fnv1a32-78229f8d",
              "promotionState": "promoted-reviewed-snapshot"
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Likely, not Verified.",
            "Confidence 0.7 is below 0.8 promotion threshold.",
            "High-impact non-verified claim cannot support customer proof."
          ]
        }
      ],
      "sourceRefs": {
        "sourceRecordCount": 15,
        "promotedSourceCount": 4,
        "p0GapCount": 0,
        "sourceRecords": [
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "claim:claim-mercury-flux",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "horizons-api",
            "title": "JPL Horizons API",
            "trust": "primary",
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "claim:claim-de440-boundary",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "spice-gf",
            "title": "SPICE Geometry Finder",
            "trust": "primary",
            "recordHash": "fnv1a32-97d74c96",
            "usedBy": "claim:claim-de440-boundary",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-helium3",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-spf-separation",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "nasa-dtn",
            "title": "Delay/Disruption Tolerant Networking",
            "trust": "primary",
            "recordHash": "fnv1a32-61e03fe6",
            "usedBy": "claim:claim-dtn",
            "promotionState": "not-promoted-or-not-required-p0"
          },
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "claim:claim-mercury-core",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-mercury-core",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-93c0fe91",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-ba0c45bb",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-97d74c96",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "assumption:assumption-no-mercury-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "assumption:assumption-no-mercury-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "assumption:assumption-no-mercury-first",
            "promotionState": "covered-by-assumption-source-record"
          }
        ]
      },
      "modelEvidence": {
        "modelArtifactBundleHash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "blockedArtifactCount": 7,
        "artifactCount": 7
      },
      "runtimeEvidence": {
        "sidecarPromotionLedgerHash": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "promotedRuntimeArtifactCount": 3,
        "runtimeContractGapCount": 3,
        "runSpecPacketHash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
        "artifactTemplatePacketHash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86"
      },
      "blockerCount": 9,
      "blockers": [
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "gmat-transfer-v1 runtime evidence missing for moon-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for moon-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound."
      ],
      "allowedUse": "Scenario trace is decision-support evidence only; it is not an operational mission design, resource reserve statement, or investment recommendation.",
      "traceHash": "sha256-4c9d51ef9294289600bc39fd2b99a03df6edf38557eb137e1a48a9bf1b0d3110"
    },
    {
      "scenarioId": "hybrid",
      "name": "Hybrid Moon -> Asteroid -> Mercury",
      "rank": 2,
      "decisionLane": "lane-3-watchlist",
      "promotionState": "blocked-for-commercial-proof",
      "commercializationAllowed": false,
      "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803",
      "deterministicScores": {
        "benefitScore": 80.53,
        "riskScore": 47.09,
        "uncertaintyPenalty": 12,
        "utility": 65.69
      },
      "uncertainty": {
        "iterations": 128,
        "utilityP10": 63.58,
        "utilityMedian": 65.8,
        "utilityP90": 67.74,
        "downsideSpread": 2.22,
        "seed": "hybrid-decision-ledger"
      },
      "economics": {
        "businessReadinessMedian": 72.59,
        "businessReadinessP10": 66.95,
        "businessReadinessP90": 78.5,
        "medianProgramNeedBn": 61.38,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 24.22,
        "underfundedProbabilityPercent": 0.39
      },
      "topDrivers": {
        "benefits": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 92,
            "weight": 1,
            "weightedValue": 92
          },
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 82,
            "weight": 1,
            "weightedValue": 82
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 82,
            "weight": 1,
            "weightedValue": 82
          }
        ],
        "risks": [
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 55,
            "weight": 1,
            "weightedValue": 55
          },
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 46,
            "weight": 1,
            "weightedValue": 46
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 45,
            "weight": 0.9,
            "weightedValue": 40.5
          }
        ]
      },
      "runRefs": [
        {
          "id": "run-hybrid-base-2026-06-19",
          "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
          "claimState": "model-derived-unvalidated",
          "selectedUtility": 65.69,
          "purpose": "Canonical beta decision-support run used for the generated feasibility report.",
          "inputHashes": {
            "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
            "weights": "sha256-5131a19946c87940b7042077430239d4ccf731cd2fe8966b65fa108782d2e6e9",
            "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
            "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
            "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
          },
          "evidenceHashes": {
            "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
            "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
            "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
          }
        }
      ],
      "assumptionRefs": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "uncertainty": "Low",
          "utilityDelta": -0.21,
          "rankDelta": 0,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts.",
          "impactHash": "sha256-18d17b3a43121dce702111672030500b3f2312262307f39aadb9177aeff29eb8",
          "sourceCoverage": {
            "sourceCount": 4,
            "missingSourceIds": [],
            "primarySourceCount": 4,
            "recordHashes": [
              "fnv1a32-9335c241",
              "fnv1a32-93c0fe91",
              "fnv1a32-ba0c45bb",
              "fnv1a32-97d74c96"
            ]
          }
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "uncertainty": "Low",
          "utilityDelta": 0.16,
          "rankDelta": 0,
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury.",
          "impactHash": "sha256-af29cde19803c251fdb159311a364c052dcab8378ad33efccbe4fa6641075228",
          "sourceCoverage": {
            "sourceCount": 3,
            "missingSourceIds": [],
            "primarySourceCount": 3,
            "recordHashes": [
              "fnv1a32-9335c241",
              "fnv1a32-7c477cc2",
              "fnv1a32-78229f8d"
            ]
          }
        },
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "High",
          "utilityDelta": -0.86,
          "rankDelta": 0,
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion.",
          "impactHash": "sha256-6d5911577e95f4f378f9c3b42381e039f24031c5391857cc77eb0fc0e1658c49",
          "sourceCoverage": {
            "sourceCount": 3,
            "missingSourceIds": [],
            "primarySourceCount": 3,
            "recordHashes": [
              "fnv1a32-7c477cc2",
              "fnv1a32-93c0fe91",
              "fnv1a32-ba0c45bb"
            ]
          }
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "Low",
          "utilityDelta": -0.07,
          "rankDelta": 0,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge.",
          "impactHash": "sha256-debdf52af9c609f7587809b69b32742d46d4550f56dbdecfae2dc25a5571fdad",
          "sourceCoverage": {
            "sourceCount": 0,
            "missingSourceIds": [],
            "primarySourceCount": 0,
            "recordHashes": []
          }
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "High",
          "utilityDelta": -0.07,
          "rankDelta": 0,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "impactHash": "sha256-4f535d33727617984ce47c8117d7e5b03da271ddd6a54e14c07b7a083a7675b3",
          "sourceCoverage": {
            "sourceCount": 0,
            "missingSourceIds": [],
            "primarySourceCount": 0,
            "recordHashes": []
          }
        }
      ],
      "claimRefs": [
        {
          "claimId": "claim-mercury-flux",
          "domain": "Energy",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373",
          "sourceRefs": [
            {
              "sourceId": "nasa-mercury",
              "title": "Mercury Facts",
              "trust": "primary",
              "recordHash": "fnv1a32-78229f8d",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-de440-boundary",
          "domain": "Ephemeris",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb",
          "sourceRefs": [
            {
              "sourceId": "horizons-api",
              "title": "JPL Horizons API",
              "trust": "primary",
              "recordHash": "fnv1a32-9335c241",
              "promotionState": "promoted-reviewed-snapshot"
            },
            {
              "sourceId": "spice-gf",
              "title": "SPICE Geometry Finder",
              "trust": "primary",
              "recordHash": "fnv1a32-97d74c96",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-helium3",
          "domain": "Resources",
          "evidenceGrade": "D-blocked",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4",
          "sourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Hypothesis, not Verified.",
            "Confidence 0.25 is below 0.8 promotion threshold."
          ]
        },
        {
          "claimId": "claim-spf-separation",
          "domain": "Manufacturing",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359",
          "sourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Likely, not Verified.",
            "Confidence 0.78 is below 0.8 promotion threshold.",
            "High-impact non-verified claim cannot support customer proof."
          ]
        },
        {
          "claimId": "claim-dtn",
          "domain": "Comms",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46",
          "sourceRefs": [
            {
              "sourceId": "nasa-dtn",
              "title": "Delay/Disruption Tolerant Networking",
              "trust": "primary",
              "recordHash": "fnv1a32-61e03fe6",
              "promotionState": "not-promoted-or-not-required-p0"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-mercury-core",
          "domain": "Resources",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9",
          "sourceRefs": [
            {
              "sourceId": "nasa-mercury",
              "title": "Mercury Facts",
              "trust": "primary",
              "recordHash": "fnv1a32-78229f8d",
              "promotionState": "promoted-reviewed-snapshot"
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Likely, not Verified.",
            "Confidence 0.7 is below 0.8 promotion threshold.",
            "High-impact non-verified claim cannot support customer proof."
          ]
        }
      ],
      "sourceRefs": {
        "sourceRecordCount": 18,
        "promotedSourceCount": 4,
        "p0GapCount": 0,
        "sourceRecords": [
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "claim:claim-mercury-flux",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "horizons-api",
            "title": "JPL Horizons API",
            "trust": "primary",
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "claim:claim-de440-boundary",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "spice-gf",
            "title": "SPICE Geometry Finder",
            "trust": "primary",
            "recordHash": "fnv1a32-97d74c96",
            "usedBy": "claim:claim-de440-boundary",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-helium3",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-spf-separation",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "nasa-dtn",
            "title": "Delay/Disruption Tolerant Networking",
            "trust": "primary",
            "recordHash": "fnv1a32-61e03fe6",
            "usedBy": "claim:claim-dtn",
            "promotionState": "not-promoted-or-not-required-p0"
          },
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "claim:claim-mercury-core",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-mercury-core",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-93c0fe91",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-ba0c45bb",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-97d74c96",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "assumption:assumption-no-mercury-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "assumption:assumption-no-mercury-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "assumption:assumption-no-mercury-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "assumption:assumption-resource-composition-unknown",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-93c0fe91",
            "usedBy": "assumption:assumption-resource-composition-unknown",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-ba0c45bb",
            "usedBy": "assumption:assumption-resource-composition-unknown",
            "promotionState": "covered-by-assumption-source-record"
          }
        ]
      },
      "modelEvidence": {
        "modelArtifactBundleHash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "blockedArtifactCount": 7,
        "artifactCount": 7
      },
      "runtimeEvidence": {
        "sidecarPromotionLedgerHash": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "promotedRuntimeArtifactCount": 3,
        "runtimeContractGapCount": 3,
        "runSpecPacketHash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
        "artifactTemplatePacketHash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86"
      },
      "blockerCount": 11,
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "tudat-transfer-v1 runtime evidence missing for hybrid: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "allowedUse": "Scenario trace is decision-support evidence only; it is not an operational mission design, resource reserve statement, or investment recommendation.",
      "traceHash": "sha256-d733f88bb38e404138d4ac8f6cca29c216f96ef4cfab8d1feb018406ef47b92d"
    },
    {
      "scenarioId": "asteroid-first",
      "name": "Asteroid Feedstock-first",
      "rank": 3,
      "decisionLane": "lane-4-research-backlog",
      "promotionState": "blocked-for-commercial-proof",
      "commercializationAllowed": false,
      "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051",
      "deterministicScores": {
        "benefitScore": 69.21,
        "riskScore": 54.8,
        "uncertaintyPenalty": 18,
        "utility": 51.37
      },
      "uncertainty": {
        "iterations": 128,
        "utilityP10": 48.51,
        "utilityMedian": 51.07,
        "utilityP90": 54.39,
        "downsideSpread": 2.55,
        "seed": "asteroid-first-decision-ledger"
      },
      "economics": {
        "businessReadinessMedian": 59.76,
        "businessReadinessP10": 52.92,
        "businessReadinessP90": 67.27,
        "medianProgramNeedBn": 70,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 0,
        "underfundedProbabilityPercent": 2.73
      },
      "topDrivers": {
        "benefits": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 84,
            "weight": 1,
            "weightedValue": 84
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 75,
            "weight": 1,
            "weightedValue": 75
          },
          {
            "kind": "benefit",
            "criterion": "vacuum",
            "rawScore": 85,
            "weight": 0.75,
            "weightedValue": 63.75
          }
        ],
        "risks": [
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 72,
            "weight": 1,
            "weightedValue": 72
          },
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 58,
            "weight": 1,
            "weightedValue": 58
          },
          {
            "kind": "risk",
            "criterion": "processMaturity",
            "rawScore": 55,
            "weight": 0.8,
            "weightedValue": 44
          }
        ]
      },
      "runRefs": [
        {
          "id": "run-asteroid-feedstock-probe-2026-06-19",
          "runHash": "sha256-68cd75732797695c5aecb33617bd5132129608750a763e4c998d9e22bf4d1b22",
          "claimState": "model-derived-unvalidated",
          "selectedUtility": 51.37,
          "purpose": "Probe whether asteroid scenarios can compete before candidate-specific taxonomy, spectra, or mission evidence exists.",
          "inputHashes": {
            "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
            "weights": "sha256-3a819aa26d821b001a6fa4b0c2ae9cd86f281248a724dd0068a497910827626b",
            "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
            "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
            "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
          },
          "evidenceHashes": {
            "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
            "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
            "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
          }
        }
      ],
      "assumptionRefs": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "uncertainty": "Low",
          "utilityDelta": -0.46,
          "rankDelta": 0,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts.",
          "impactHash": "sha256-18d17b3a43121dce702111672030500b3f2312262307f39aadb9177aeff29eb8",
          "sourceCoverage": {
            "sourceCount": 4,
            "missingSourceIds": [],
            "primarySourceCount": 4,
            "recordHashes": [
              "fnv1a32-9335c241",
              "fnv1a32-93c0fe91",
              "fnv1a32-ba0c45bb",
              "fnv1a32-97d74c96"
            ]
          }
        },
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "High",
          "utilityDelta": -1.68,
          "rankDelta": 0,
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion.",
          "impactHash": "sha256-6d5911577e95f4f378f9c3b42381e039f24031c5391857cc77eb0fc0e1658c49",
          "sourceCoverage": {
            "sourceCount": 3,
            "missingSourceIds": [],
            "primarySourceCount": 3,
            "recordHashes": [
              "fnv1a32-7c477cc2",
              "fnv1a32-93c0fe91",
              "fnv1a32-ba0c45bb"
            ]
          }
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "Low",
          "utilityDelta": -0.09,
          "rankDelta": 0,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge.",
          "impactHash": "sha256-debdf52af9c609f7587809b69b32742d46d4550f56dbdecfae2dc25a5571fdad",
          "sourceCoverage": {
            "sourceCount": 0,
            "missingSourceIds": [],
            "primarySourceCount": 0,
            "recordHashes": []
          }
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "High",
          "utilityDelta": -0.39,
          "rankDelta": 0,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "impactHash": "sha256-4f535d33727617984ce47c8117d7e5b03da271ddd6a54e14c07b7a083a7675b3",
          "sourceCoverage": {
            "sourceCount": 0,
            "missingSourceIds": [],
            "primarySourceCount": 0,
            "recordHashes": []
          }
        }
      ],
      "claimRefs": [
        {
          "claimId": "claim-mercury-flux",
          "domain": "Energy",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373",
          "sourceRefs": [
            {
              "sourceId": "nasa-mercury",
              "title": "Mercury Facts",
              "trust": "primary",
              "recordHash": "fnv1a32-78229f8d",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-de440-boundary",
          "domain": "Ephemeris",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb",
          "sourceRefs": [
            {
              "sourceId": "horizons-api",
              "title": "JPL Horizons API",
              "trust": "primary",
              "recordHash": "fnv1a32-9335c241",
              "promotionState": "promoted-reviewed-snapshot"
            },
            {
              "sourceId": "spice-gf",
              "title": "SPICE Geometry Finder",
              "trust": "primary",
              "recordHash": "fnv1a32-97d74c96",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-helium3",
          "domain": "Resources",
          "evidenceGrade": "D-blocked",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4",
          "sourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Hypothesis, not Verified.",
            "Confidence 0.25 is below 0.8 promotion threshold."
          ]
        },
        {
          "claimId": "claim-spf-separation",
          "domain": "Manufacturing",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359",
          "sourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Likely, not Verified.",
            "Confidence 0.78 is below 0.8 promotion threshold.",
            "High-impact non-verified claim cannot support customer proof."
          ]
        },
        {
          "claimId": "claim-dtn",
          "domain": "Comms",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46",
          "sourceRefs": [
            {
              "sourceId": "nasa-dtn",
              "title": "Delay/Disruption Tolerant Networking",
              "trust": "primary",
              "recordHash": "fnv1a32-61e03fe6",
              "promotionState": "not-promoted-or-not-required-p0"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-mercury-core",
          "domain": "Resources",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9",
          "sourceRefs": [
            {
              "sourceId": "nasa-mercury",
              "title": "Mercury Facts",
              "trust": "primary",
              "recordHash": "fnv1a32-78229f8d",
              "promotionState": "promoted-reviewed-snapshot"
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Likely, not Verified.",
            "Confidence 0.7 is below 0.8 promotion threshold.",
            "High-impact non-verified claim cannot support customer proof."
          ]
        }
      ],
      "sourceRefs": {
        "sourceRecordCount": 15,
        "promotedSourceCount": 4,
        "p0GapCount": 0,
        "sourceRecords": [
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "claim:claim-mercury-flux",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "horizons-api",
            "title": "JPL Horizons API",
            "trust": "primary",
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "claim:claim-de440-boundary",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "spice-gf",
            "title": "SPICE Geometry Finder",
            "trust": "primary",
            "recordHash": "fnv1a32-97d74c96",
            "usedBy": "claim:claim-de440-boundary",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-helium3",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-spf-separation",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "nasa-dtn",
            "title": "Delay/Disruption Tolerant Networking",
            "trust": "primary",
            "recordHash": "fnv1a32-61e03fe6",
            "usedBy": "claim:claim-dtn",
            "promotionState": "not-promoted-or-not-required-p0"
          },
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "claim:claim-mercury-core",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-mercury-core",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-93c0fe91",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-ba0c45bb",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-97d74c96",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "assumption:assumption-resource-composition-unknown",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-93c0fe91",
            "usedBy": "assumption:assumption-resource-composition-unknown",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-ba0c45bb",
            "usedBy": "assumption:assumption-resource-composition-unknown",
            "promotionState": "covered-by-assumption-source-record"
          }
        ]
      },
      "modelEvidence": {
        "modelArtifactBundleHash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "blockedArtifactCount": 7,
        "artifactCount": 7
      },
      "runtimeEvidence": {
        "sidecarPromotionLedgerHash": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "promotedRuntimeArtifactCount": 3,
        "runtimeContractGapCount": 3,
        "runSpecPacketHash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
        "artifactTemplatePacketHash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86"
      },
      "blockerCount": 12,
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Candidate-specific SBDB/CAD/taxonomy/spectra evidence required before resource promotion.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "gmat-transfer-v1 runtime evidence missing for asteroid-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for asteroid-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "tudat-transfer-v1 runtime evidence missing for asteroid-first: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "allowedUse": "Scenario trace is decision-support evidence only; it is not an operational mission design, resource reserve statement, or investment recommendation.",
      "traceHash": "sha256-d619bbef18fc804057f0cf68a6279068db56356135bf425e70958c3f1b2b904b"
    },
    {
      "scenarioId": "mercury-orbit",
      "name": "Mercury Orbit-first",
      "rank": 4,
      "decisionLane": "lane-4-research-backlog",
      "promotionState": "blocked-for-commercial-proof",
      "commercializationAllowed": false,
      "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4",
      "deterministicScores": {
        "benefitScore": 80.84,
        "riskScore": 75.96,
        "uncertaintyPenalty": 24,
        "utility": 42.95
      },
      "uncertainty": {
        "iterations": 128,
        "utilityP10": 38.9,
        "utilityMedian": 42.78,
        "utilityP90": 46.63,
        "downsideSpread": 3.87,
        "seed": "mercury-orbit-decision-ledger"
      },
      "economics": {
        "businessReadinessMedian": 55.33,
        "businessReadinessP10": 45.88,
        "businessReadinessP90": 64.63,
        "medianProgramNeedBn": 97.54,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 0,
        "underfundedProbabilityPercent": 10.94
      },
      "topDrivers": {
        "benefits": [
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 97,
            "weight": 1,
            "weightedValue": 97
          },
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 86,
            "weight": 1,
            "weightedValue": 86
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 84,
            "weight": 1,
            "weightedValue": 84
          }
        ],
        "risks": [
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 86,
            "weight": 1,
            "weightedValue": 86
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 82,
            "weight": 0.9,
            "weightedValue": 73.8
          },
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 70,
            "weight": 1,
            "weightedValue": 70
          }
        ]
      },
      "runRefs": [],
      "assumptionRefs": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "uncertainty": "Low",
          "utilityDelta": -0.04,
          "rankDelta": 0,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts.",
          "impactHash": "sha256-18d17b3a43121dce702111672030500b3f2312262307f39aadb9177aeff29eb8",
          "sourceCoverage": {
            "sourceCount": 4,
            "missingSourceIds": [],
            "primarySourceCount": 4,
            "recordHashes": [
              "fnv1a32-9335c241",
              "fnv1a32-93c0fe91",
              "fnv1a32-ba0c45bb",
              "fnv1a32-97d74c96"
            ]
          }
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "uncertainty": "Low",
          "utilityDelta": -0.28,
          "rankDelta": 0,
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury.",
          "impactHash": "sha256-af29cde19803c251fdb159311a364c052dcab8378ad33efccbe4fa6641075228",
          "sourceCoverage": {
            "sourceCount": 3,
            "missingSourceIds": [],
            "primarySourceCount": 3,
            "recordHashes": [
              "fnv1a32-9335c241",
              "fnv1a32-7c477cc2",
              "fnv1a32-78229f8d"
            ]
          }
        },
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "High",
          "utilityDelta": -0.82,
          "rankDelta": 0,
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion.",
          "impactHash": "sha256-6d5911577e95f4f378f9c3b42381e039f24031c5391857cc77eb0fc0e1658c49",
          "sourceCoverage": {
            "sourceCount": 3,
            "missingSourceIds": [],
            "primarySourceCount": 3,
            "recordHashes": [
              "fnv1a32-7c477cc2",
              "fnv1a32-93c0fe91",
              "fnv1a32-ba0c45bb"
            ]
          }
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "Low",
          "utilityDelta": 0.03,
          "rankDelta": 0,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge.",
          "impactHash": "sha256-debdf52af9c609f7587809b69b32742d46d4550f56dbdecfae2dc25a5571fdad",
          "sourceCoverage": {
            "sourceCount": 0,
            "missingSourceIds": [],
            "primarySourceCount": 0,
            "recordHashes": []
          }
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "High",
          "utilityDelta": -0.67,
          "rankDelta": 0,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "impactHash": "sha256-4f535d33727617984ce47c8117d7e5b03da271ddd6a54e14c07b7a083a7675b3",
          "sourceCoverage": {
            "sourceCount": 0,
            "missingSourceIds": [],
            "primarySourceCount": 0,
            "recordHashes": []
          }
        }
      ],
      "claimRefs": [
        {
          "claimId": "claim-mercury-flux",
          "domain": "Energy",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373",
          "sourceRefs": [
            {
              "sourceId": "nasa-mercury",
              "title": "Mercury Facts",
              "trust": "primary",
              "recordHash": "fnv1a32-78229f8d",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-de440-boundary",
          "domain": "Ephemeris",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb",
          "sourceRefs": [
            {
              "sourceId": "horizons-api",
              "title": "JPL Horizons API",
              "trust": "primary",
              "recordHash": "fnv1a32-9335c241",
              "promotionState": "promoted-reviewed-snapshot"
            },
            {
              "sourceId": "spice-gf",
              "title": "SPICE Geometry Finder",
              "trust": "primary",
              "recordHash": "fnv1a32-97d74c96",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-helium3",
          "domain": "Resources",
          "evidenceGrade": "D-blocked",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4",
          "sourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Hypothesis, not Verified.",
            "Confidence 0.25 is below 0.8 promotion threshold."
          ]
        },
        {
          "claimId": "claim-spf-separation",
          "domain": "Manufacturing",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359",
          "sourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Likely, not Verified.",
            "Confidence 0.78 is below 0.8 promotion threshold.",
            "High-impact non-verified claim cannot support customer proof."
          ]
        },
        {
          "claimId": "claim-dtn",
          "domain": "Comms",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46",
          "sourceRefs": [
            {
              "sourceId": "nasa-dtn",
              "title": "Delay/Disruption Tolerant Networking",
              "trust": "primary",
              "recordHash": "fnv1a32-61e03fe6",
              "promotionState": "not-promoted-or-not-required-p0"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-mercury-core",
          "domain": "Resources",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9",
          "sourceRefs": [
            {
              "sourceId": "nasa-mercury",
              "title": "Mercury Facts",
              "trust": "primary",
              "recordHash": "fnv1a32-78229f8d",
              "promotionState": "promoted-reviewed-snapshot"
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Likely, not Verified.",
            "Confidence 0.7 is below 0.8 promotion threshold.",
            "High-impact non-verified claim cannot support customer proof."
          ]
        }
      ],
      "sourceRefs": {
        "sourceRecordCount": 18,
        "promotedSourceCount": 4,
        "p0GapCount": 0,
        "sourceRecords": [
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "claim:claim-mercury-flux",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "horizons-api",
            "title": "JPL Horizons API",
            "trust": "primary",
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "claim:claim-de440-boundary",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "spice-gf",
            "title": "SPICE Geometry Finder",
            "trust": "primary",
            "recordHash": "fnv1a32-97d74c96",
            "usedBy": "claim:claim-de440-boundary",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-helium3",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-spf-separation",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "nasa-dtn",
            "title": "Delay/Disruption Tolerant Networking",
            "trust": "primary",
            "recordHash": "fnv1a32-61e03fe6",
            "usedBy": "claim:claim-dtn",
            "promotionState": "not-promoted-or-not-required-p0"
          },
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "claim:claim-mercury-core",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-mercury-core",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-93c0fe91",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-ba0c45bb",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-97d74c96",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "assumption:assumption-no-mercury-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "assumption:assumption-no-mercury-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "assumption:assumption-no-mercury-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "assumption:assumption-resource-composition-unknown",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-93c0fe91",
            "usedBy": "assumption:assumption-resource-composition-unknown",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-ba0c45bb",
            "usedBy": "assumption:assumption-resource-composition-unknown",
            "promotionState": "covered-by-assumption-source-record"
          }
        ]
      },
      "modelEvidence": {
        "modelArtifactBundleHash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "blockedArtifactCount": 7,
        "artifactCount": 7
      },
      "runtimeEvidence": {
        "sidecarPromotionLedgerHash": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "promotedRuntimeArtifactCount": 3,
        "runtimeContractGapCount": 3,
        "runSpecPacketHash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
        "artifactTemplatePacketHash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86"
      },
      "blockerCount": 12,
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "gmat-transfer-v1 runtime evidence missing for mercury-orbit: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "Mercury thermal/comms/logistics claims require runtime event-window and trajectory artifacts.",
        "orekit-propagation-v1 runtime evidence missing for mercury-orbit: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "tudat-transfer-v1 runtime evidence missing for mercury-orbit: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "allowedUse": "Scenario trace is decision-support evidence only; it is not an operational mission design, resource reserve statement, or investment recommendation.",
      "traceHash": "sha256-347c3c0291493190d1eaba179b7e37c09366c6c992e8e7a322640eee5bd05757"
    },
    {
      "scenarioId": "mars-first",
      "name": "Mars-first Conventional Expansion",
      "rank": 5,
      "decisionLane": "lane-4-research-backlog",
      "promotionState": "blocked-for-commercial-proof",
      "commercializationAllowed": false,
      "decisionHash": "sha256-81bc9923440bb378abb0e1f0e16683f5e7d4df6014535645506f115bb13313bb",
      "deterministicScores": {
        "benefitScore": 48.11,
        "riskScore": 54.84,
        "uncertaintyPenalty": 12,
        "utility": 40.78
      },
      "uncertainty": {
        "iterations": 128,
        "utilityP10": 38.16,
        "utilityMedian": 40.96,
        "utilityP90": 43.65,
        "downsideSpread": 2.8,
        "seed": "mars-first-decision-ledger"
      },
      "economics": {
        "businessReadinessMedian": 63.22,
        "businessReadinessP10": 57.41,
        "businessReadinessP90": 68.72,
        "medianProgramNeedBn": 68.05,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 0,
        "underfundedProbabilityPercent": 1.95
      },
      "topDrivers": {
        "benefits": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 65,
            "weight": 1,
            "weightedValue": 65
          },
          {
            "kind": "benefit",
            "criterion": "resourceConfidence",
            "rawScore": 65,
            "weight": 1,
            "weightedValue": 65
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 46,
            "weight": 1,
            "weightedValue": 46
          }
        ],
        "risks": [
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 62,
            "weight": 1,
            "weightedValue": 62
          },
          {
            "kind": "risk",
            "criterion": "comms",
            "rawScore": 64,
            "weight": 0.8,
            "weightedValue": 51.2
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 56,
            "weight": 0.9,
            "weightedValue": 50.4
          }
        ]
      },
      "runRefs": [],
      "assumptionRefs": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "uncertainty": "Low",
          "utilityDelta": 0.33,
          "rankDelta": 0,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts.",
          "impactHash": "sha256-18d17b3a43121dce702111672030500b3f2312262307f39aadb9177aeff29eb8",
          "sourceCoverage": {
            "sourceCount": 4,
            "missingSourceIds": [],
            "primarySourceCount": 4,
            "recordHashes": [
              "fnv1a32-9335c241",
              "fnv1a32-93c0fe91",
              "fnv1a32-ba0c45bb",
              "fnv1a32-97d74c96"
            ]
          }
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "Low",
          "utilityDelta": -0.06,
          "rankDelta": 0,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge.",
          "impactHash": "sha256-debdf52af9c609f7587809b69b32742d46d4550f56dbdecfae2dc25a5571fdad",
          "sourceCoverage": {
            "sourceCount": 0,
            "missingSourceIds": [],
            "primarySourceCount": 0,
            "recordHashes": []
          }
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "High",
          "utilityDelta": -0.05,
          "rankDelta": 0,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "impactHash": "sha256-4f535d33727617984ce47c8117d7e5b03da271ddd6a54e14c07b7a083a7675b3",
          "sourceCoverage": {
            "sourceCount": 0,
            "missingSourceIds": [],
            "primarySourceCount": 0,
            "recordHashes": []
          }
        }
      ],
      "claimRefs": [
        {
          "claimId": "claim-mercury-flux",
          "domain": "Energy",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373",
          "sourceRefs": [
            {
              "sourceId": "nasa-mercury",
              "title": "Mercury Facts",
              "trust": "primary",
              "recordHash": "fnv1a32-78229f8d",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-de440-boundary",
          "domain": "Ephemeris",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb",
          "sourceRefs": [
            {
              "sourceId": "horizons-api",
              "title": "JPL Horizons API",
              "trust": "primary",
              "recordHash": "fnv1a32-9335c241",
              "promotionState": "promoted-reviewed-snapshot"
            },
            {
              "sourceId": "spice-gf",
              "title": "SPICE Geometry Finder",
              "trust": "primary",
              "recordHash": "fnv1a32-97d74c96",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-helium3",
          "domain": "Resources",
          "evidenceGrade": "D-blocked",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4",
          "sourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Hypothesis, not Verified.",
            "Confidence 0.25 is below 0.8 promotion threshold."
          ]
        },
        {
          "claimId": "claim-spf-separation",
          "domain": "Manufacturing",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359",
          "sourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Likely, not Verified.",
            "Confidence 0.78 is below 0.8 promotion threshold.",
            "High-impact non-verified claim cannot support customer proof."
          ]
        },
        {
          "claimId": "claim-dtn",
          "domain": "Comms",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46",
          "sourceRefs": [
            {
              "sourceId": "nasa-dtn",
              "title": "Delay/Disruption Tolerant Networking",
              "trust": "primary",
              "recordHash": "fnv1a32-61e03fe6",
              "promotionState": "not-promoted-or-not-required-p0"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-mercury-core",
          "domain": "Resources",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9",
          "sourceRefs": [
            {
              "sourceId": "nasa-mercury",
              "title": "Mercury Facts",
              "trust": "primary",
              "recordHash": "fnv1a32-78229f8d",
              "promotionState": "promoted-reviewed-snapshot"
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Likely, not Verified.",
            "Confidence 0.7 is below 0.8 promotion threshold.",
            "High-impact non-verified claim cannot support customer proof."
          ]
        }
      ],
      "sourceRefs": {
        "sourceRecordCount": 12,
        "promotedSourceCount": 4,
        "p0GapCount": 0,
        "sourceRecords": [
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "claim:claim-mercury-flux",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "horizons-api",
            "title": "JPL Horizons API",
            "trust": "primary",
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "claim:claim-de440-boundary",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "spice-gf",
            "title": "SPICE Geometry Finder",
            "trust": "primary",
            "recordHash": "fnv1a32-97d74c96",
            "usedBy": "claim:claim-de440-boundary",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-helium3",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-spf-separation",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "nasa-dtn",
            "title": "Delay/Disruption Tolerant Networking",
            "trust": "primary",
            "recordHash": "fnv1a32-61e03fe6",
            "usedBy": "claim:claim-dtn",
            "promotionState": "not-promoted-or-not-required-p0"
          },
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "claim:claim-mercury-core",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-mercury-core",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-93c0fe91",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-ba0c45bb",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-97d74c96",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          }
        ]
      },
      "modelEvidence": {
        "modelArtifactBundleHash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "blockedArtifactCount": 7,
        "artifactCount": 7
      },
      "runtimeEvidence": {
        "sidecarPromotionLedgerHash": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "promotedRuntimeArtifactCount": 3,
        "runtimeContractGapCount": 3,
        "runSpecPacketHash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
        "artifactTemplatePacketHash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86"
      },
      "blockerCount": 10,
      "blockers": [
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "gmat-transfer-v1 runtime evidence missing for mars-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mars-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "tudat-transfer-v1 runtime evidence missing for mars-first: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "allowedUse": "Scenario trace is decision-support evidence only; it is not an operational mission design, resource reserve statement, or investment recommendation.",
      "traceHash": "sha256-fd5108fc370a65f836309389af914613680a45a2f8d2cd12b9f04f65a9a39068"
    },
    {
      "scenarioId": "mercury-polar",
      "name": "Mercury Polar Surface-first",
      "rank": 6,
      "decisionLane": "lane-4-research-backlog",
      "promotionState": "blocked-for-commercial-proof",
      "commercializationAllowed": false,
      "decisionHash": "sha256-8bcef4c6d0b17543fd330abfe053478152e09a623045d677ca24c9f669159934",
      "deterministicScores": {
        "benefitScore": 76.32,
        "riskScore": 78.13,
        "uncertaintyPenalty": 26,
        "utility": 37.95
      },
      "uncertainty": {
        "iterations": 128,
        "utilityP10": 33.71,
        "utilityMedian": 37.84,
        "utilityP90": 41.82,
        "downsideSpread": 4.13,
        "seed": "mercury-polar-decision-ledger"
      },
      "economics": {
        "businessReadinessMedian": 53.68,
        "businessReadinessP10": 44.62,
        "businessReadinessP90": 63.86,
        "medianProgramNeedBn": 104.1,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 0,
        "underfundedProbabilityPercent": 11.91
      },
      "topDrivers": {
        "benefits": [
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 88,
            "weight": 1,
            "weightedValue": 88
          },
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 80,
            "weight": 1,
            "weightedValue": 80
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 74,
            "weight": 1,
            "weightedValue": 74
          }
        ],
        "risks": [
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 90,
            "weight": 1,
            "weightedValue": 90
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 88,
            "weight": 0.9,
            "weightedValue": 79.2
          },
          {
            "kind": "risk",
            "criterion": "comms",
            "rawScore": 82,
            "weight": 0.8,
            "weightedValue": 65.6
          }
        ]
      },
      "runRefs": [],
      "assumptionRefs": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "uncertainty": "Low",
          "utilityDelta": 0.17,
          "rankDelta": 0,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts.",
          "impactHash": "sha256-18d17b3a43121dce702111672030500b3f2312262307f39aadb9177aeff29eb8",
          "sourceCoverage": {
            "sourceCount": 4,
            "missingSourceIds": [],
            "primarySourceCount": 4,
            "recordHashes": [
              "fnv1a32-9335c241",
              "fnv1a32-93c0fe91",
              "fnv1a32-ba0c45bb",
              "fnv1a32-97d74c96"
            ]
          }
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "uncertainty": "Low",
          "utilityDelta": -0.45,
          "rankDelta": 0,
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury.",
          "impactHash": "sha256-af29cde19803c251fdb159311a364c052dcab8378ad33efccbe4fa6641075228",
          "sourceCoverage": {
            "sourceCount": 3,
            "missingSourceIds": [],
            "primarySourceCount": 3,
            "recordHashes": [
              "fnv1a32-9335c241",
              "fnv1a32-7c477cc2",
              "fnv1a32-78229f8d"
            ]
          }
        },
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "High",
          "utilityDelta": -0.04,
          "rankDelta": 0,
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion.",
          "impactHash": "sha256-6d5911577e95f4f378f9c3b42381e039f24031c5391857cc77eb0fc0e1658c49",
          "sourceCoverage": {
            "sourceCount": 3,
            "missingSourceIds": [],
            "primarySourceCount": 3,
            "recordHashes": [
              "fnv1a32-7c477cc2",
              "fnv1a32-93c0fe91",
              "fnv1a32-ba0c45bb"
            ]
          }
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "Low",
          "utilityDelta": 0.03,
          "rankDelta": 0,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge.",
          "impactHash": "sha256-debdf52af9c609f7587809b69b32742d46d4550f56dbdecfae2dc25a5571fdad",
          "sourceCoverage": {
            "sourceCount": 0,
            "missingSourceIds": [],
            "primarySourceCount": 0,
            "recordHashes": []
          }
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "uncertainty": "High",
          "utilityDelta": -0.63,
          "rankDelta": 0,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "impactHash": "sha256-4f535d33727617984ce47c8117d7e5b03da271ddd6a54e14c07b7a083a7675b3",
          "sourceCoverage": {
            "sourceCount": 0,
            "missingSourceIds": [],
            "primarySourceCount": 0,
            "recordHashes": []
          }
        }
      ],
      "claimRefs": [
        {
          "claimId": "claim-mercury-flux",
          "domain": "Energy",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373",
          "sourceRefs": [
            {
              "sourceId": "nasa-mercury",
              "title": "Mercury Facts",
              "trust": "primary",
              "recordHash": "fnv1a32-78229f8d",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-de440-boundary",
          "domain": "Ephemeris",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb",
          "sourceRefs": [
            {
              "sourceId": "horizons-api",
              "title": "JPL Horizons API",
              "trust": "primary",
              "recordHash": "fnv1a32-9335c241",
              "promotionState": "promoted-reviewed-snapshot"
            },
            {
              "sourceId": "spice-gf",
              "title": "SPICE Geometry Finder",
              "trust": "primary",
              "recordHash": "fnv1a32-97d74c96",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-helium3",
          "domain": "Resources",
          "evidenceGrade": "D-blocked",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4",
          "sourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Hypothesis, not Verified.",
            "Confidence 0.25 is below 0.8 promotion threshold."
          ]
        },
        {
          "claimId": "claim-spf-separation",
          "domain": "Manufacturing",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359",
          "sourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Likely, not Verified.",
            "Confidence 0.78 is below 0.8 promotion threshold.",
            "High-impact non-verified claim cannot support customer proof."
          ]
        },
        {
          "claimId": "claim-dtn",
          "domain": "Comms",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true,
          "promotionState": "verified-citable-beta-evidence",
          "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46",
          "sourceRefs": [
            {
              "sourceId": "nasa-dtn",
              "title": "Delay/Disruption Tolerant Networking",
              "trust": "primary",
              "recordHash": "fnv1a32-61e03fe6",
              "promotionState": "not-promoted-or-not-required-p0"
            }
          ],
          "blockers": []
        },
        {
          "claimId": "claim-mercury-core",
          "domain": "Resources",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false,
          "promotionState": "blocked-for-commercial-proof",
          "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9",
          "sourceRefs": [
            {
              "sourceId": "nasa-mercury",
              "title": "Mercury Facts",
              "trust": "primary",
              "recordHash": "fnv1a32-78229f8d",
              "promotionState": "promoted-reviewed-snapshot"
            },
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "recordHash": "fnv1a32-7c477cc2",
              "promotionState": "promoted-reviewed-snapshot"
            }
          ],
          "blockers": [
            "Claim status is Likely, not Verified.",
            "Confidence 0.7 is below 0.8 promotion threshold.",
            "High-impact non-verified claim cannot support customer proof."
          ]
        }
      ],
      "sourceRefs": {
        "sourceRecordCount": 18,
        "promotedSourceCount": 4,
        "p0GapCount": 0,
        "sourceRecords": [
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "claim:claim-mercury-flux",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "horizons-api",
            "title": "JPL Horizons API",
            "trust": "primary",
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "claim:claim-de440-boundary",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "spice-gf",
            "title": "SPICE Geometry Finder",
            "trust": "primary",
            "recordHash": "fnv1a32-97d74c96",
            "usedBy": "claim:claim-de440-boundary",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-helium3",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-spf-separation",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "nasa-dtn",
            "title": "Delay/Disruption Tolerant Networking",
            "trust": "primary",
            "recordHash": "fnv1a32-61e03fe6",
            "usedBy": "claim:claim-dtn",
            "promotionState": "not-promoted-or-not-required-p0"
          },
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "claim:claim-mercury-core",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "claim:claim-mercury-core",
            "promotionState": "promoted-reviewed-snapshot"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-93c0fe91",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-ba0c45bb",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-97d74c96",
            "usedBy": "assumption:assumption-snapshot-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-9335c241",
            "usedBy": "assumption:assumption-no-mercury-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "assumption:assumption-no-mercury-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-78229f8d",
            "usedBy": "assumption:assumption-no-mercury-first",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-7c477cc2",
            "usedBy": "assumption:assumption-resource-composition-unknown",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-93c0fe91",
            "usedBy": "assumption:assumption-resource-composition-unknown",
            "promotionState": "covered-by-assumption-source-record"
          },
          {
            "sourceId": null,
            "title": null,
            "trust": null,
            "recordHash": "fnv1a32-ba0c45bb",
            "usedBy": "assumption:assumption-resource-composition-unknown",
            "promotionState": "covered-by-assumption-source-record"
          }
        ]
      },
      "modelEvidence": {
        "modelArtifactBundleHash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "blockedArtifactCount": 7,
        "artifactCount": 7
      },
      "runtimeEvidence": {
        "sidecarPromotionLedgerHash": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "promotedRuntimeArtifactCount": 3,
        "runtimeContractGapCount": 3,
        "runSpecPacketHash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
        "artifactTemplatePacketHash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86"
      },
      "blockerCount": 12,
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "gmat-transfer-v1 runtime evidence missing for mercury-polar: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "Mercury thermal/comms/logistics claims require runtime event-window and trajectory artifacts.",
        "orekit-propagation-v1 runtime evidence missing for mercury-polar: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "tudat-transfer-v1 runtime evidence missing for mercury-polar: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "allowedUse": "Scenario trace is decision-support evidence only; it is not an operational mission design, resource reserve statement, or investment recommendation.",
      "traceHash": "sha256-5ab13dfa8e8a9fd561a2ee8af012a052ebd58a668b19dda311f91f6532036ecf"
    }
  ],
  "matrixHash": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6"
}
;
